<template>
  <div class="hello">
    <div class="ttAccountClosure">
      <div class="main">
        <div class="leftMain inner">
          <div
            v-for="(item, index) in region"
            :class="isgaodu == item.id ? 'gaodu right' : 'gaodus right'"
            :key="index"
            @click="showClick(item.id)"
          >
            <div
              :class="isgaodu == item.id ? 'box1 boxs pointer' : 'box1 pointer'"
              ref="box1"
              @click="
                $emit('zdy_show', item.label),
                  (key = 0),
                  $emit('zdy_shows', ' ')
              "
            >
              {{ item.label }}
              <i
                :class="
                  isgaodu == item.id
                    ? 'el-icon-caret-top'
                    : 'el-icon-caret-bottom'
                "
              ></i>
            </div>
            <div v-if="isgaodu == item.id" id="box2" class="box2">
              <div
                @click.stop="$emit('zdy_shows', ' '), (key = 0)"
                :class="key == 0 ? 'pointer color' : 'pointer'"
                class="qb"
              >
                全部
              </div>
              <div class="qbs">
                <div
                  :class="key == index + 1 ? 'pointer color' : 'pointer'"
                  style="margin-right: 20px"
                  v-for="(item, index) in areaList"
                  :key="index"
                  @click.stop="$emit('zdy_shows', item), (key = index + 1)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leftmain",
  props: ["leftmain"],
  data() {
    return {
      region: [],
      isgaodu: -1,
      areaList: [],
      key: 0,
    };
  },
  watch: {
    leftmain(newValue) {
      if(newValue){
        this.isgaodu = -1
        document.querySelector(".gaodu").style.marginBottom = 0 + "px";
      }
    },
  },
  mounted() {
    // 省级
    this.$apis.addresslevel().then((res) => {
      this.region = res.data;
    });
    this.showClick(this.leftmain);
  },
  methods: {
    page(e) {
      this.$router.push({
        name: e,
        query: {
          id: 1,
        },
      });
    },
    showClick(id) {
      this.isgaodu = id;
      this.areaList = [];
      this.$apis
        .area({
          pid: id,
        })
        .then((res) => {
          for (let i in res.data) {
            this.areaList.push(res.data[i].label);
          }
        });
      setTimeout(() => {
        let height = document.getElementById("box2").offsetHeight;
        document.querySelector(".gaodu").style.marginBottom = height + "px";
        for (let i in document.querySelectorAll(".gaodus")) {
          document.querySelectorAll(".gaodus")[i].style.marginBottom = "0px";
        }
      }, 100);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped='scoped'>
.hello {
  width: 80%;
}
.ttAccountClosure {
  background-color: #fff;
  padding-bottom: 0;
  margin-bottom: 20px;
}
.main {
  margin: auto;
  color: #999;
}
.leftMain {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
.right {
  margin-right: 10px;
}
.box1 {
  padding-bottom: 10px;
}
.boxs {
  background-color: #f5f5f5;
  color: #c7171e;
}
.box2 {
  background-color: #f5f5f5;
  width: 100%;
  position: absolute;
  right: 0px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
i {
  font-size: 18px;
}
.color {
  color: #c7171e;
}
.qb {
  width: 7%;
}
.qbs {
  display: flex;
  flex-wrap: wrap;
  width: 90%;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
}
@media screen and (min-width: 768px) and (max-width: 991px) {
}
@media only screen and (max-width: 767px) {
  .box1 {
    white-space: nowrap;
  }
  .box2 {
    width: 70%;
    display: flex;
  }
  .leftMain {
    overflow: auto;
    flex-wrap: nowrap;
    position: static;
  }
  .hello {
    width: 70%;
  }
  .qb {
    width: 15%;
  }
  .qbs {
    width: 85%;
    flex-wrap: nowrap;
    overflow: auto;
  }
  .qbs div{
    flex-shrink: 0;
  }
}
</style>
